import React from 'react';
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';
// import DescriptionIcon from '@mui/icons-material/Description';

const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const fileExtension = '.xlsx';
const MAX_EXCEL_CELL_LENGTH = 32767;
export const exportToCSV = (apiData, fileName, SheetNames = 'data') => {
    const sanitizedData = apiData.map((row) => {
        return Object.fromEntries(
            Object.entries(row).map(([key, value]) => [
                key,
                typeof value === 'string' && value.length > MAX_EXCEL_CELL_LENGTH ? value.substring(0, MAX_EXCEL_CELL_LENGTH) : value
            ])
        );
    });
    const ws = XLSX.utils.json_to_sheet(sanitizedData);
    const wb = { Sheets: { [SheetNames]: ws }, SheetNames: [SheetNames] };
    const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
    const data = new Blob([excelBuffer], { type: fileType });
    FileSaver.saveAs(data, fileName + fileExtension);
};
// export const ExportToExcel = ({ apiData, fileName }) => {
//     return (
//         <Button
//             variant="contained"
//             color="primary"
//             spacing={1}
//             startIcon={<DescriptionIcon />}
//             onClick={(e) => exportToCSV(apiData, fileName)}
//         >
//             Export Excel
//         </Button>
//     );
// };
